import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
  TextField
} from "@material-ui/core";
import PrivateRoute from "components/authentication/PrivateRoute";
import Loading from "components/common/Loading";
import AppointmentTab from "components/home/AppointmentTab";
import PreApproved from "components/home/PreApproved";
import { notificationTime } from "libs/configs/constant";
import useAuth from "libs/hooks/useAuth";
import useModalLoading from "libs/hooks/useModalLoading";
import HttpClient from "libs/utils/HttpClient";
import { HomeAdminPage } from "pages/admin";
import DashboardPage from "pages/admin/dashboard/DashboardPage";
import KPIDashboardDetailPage from "pages/admin/kpi-dashboard/KPIDashboardDetailPage";
import KPIDashboardPage from "pages/admin/kpi-dashboard/KPIDashboardPage";
import ReportIndustryPage from "pages/admin/report/ReportIndustryPage";
import ReportKPIPage from "pages/admin/report/ReportKPIPage";
import ReportVisaTypePage from "pages/admin/report/ReportVisaTypePage";
import SettingPage from "pages/admin/setting/SettingPage";
import SmartVisaPage from "pages/admin/smart-visa/SmartVisaPage";
import {
  DesignSystemPage,
  ExtensionPage,
  HomePage,
  LoginOfflinePage,
  PersonalDetailPage,
  PersonalListPage,
  SelectRolePage,
  SelectTypeLogin
} from "pages/user";
import CancelVisaPage from "pages/user/CancelVisaPage";
import CookiePrivacyPage from "pages/user/CookiePrivacyPage";
import ForgotPasswordPage from "pages/user/ForgotPasswordPage";
import LoginPage_Darf from "pages/user/LoginPage_Darf";
import LogoutPage from "pages/user/LogoutPage";
import PersonalSignaturePage from "pages/user/PersonalSignaturePage";
import RedirectConfirmPageAgency from "pages/user/RedirectConfirmAgency";
import RedirectConfirmPage from "pages/user/RedirectConfirmPage";
import RegisterPage from "pages/user/RegisterPage";
import StatusReportPage from "pages/user/StatusReportPage";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Switch, useHistory } from "react-router-dom";
import { getNotifications } from "redux/modules/adminNotificationSlice";
import { getAllActionUser } from "redux/modules/configActionSlice";
import { getDigitalWorkpermitList } from "redux/modules/digitalWorkpermitListSlice";
import { getMasterData } from "redux/modules/masterSlice";
import { getPersonalDetail } from "redux/modules/personalSlice";
import { addPin, pinExist } from "redux/modules/pinSlice";
import { getUser } from "redux/modules/userSlice";
import {
  checkWorkPermit,
  getSmartServiceList,
  getSmartServiceListLTR
} from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  warpDialog: {
    padding: "30px",
    minWidth: "350px",
    minHeight: "200px",
  },
  warpButtonDialogSave: {
    display: "flex",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  textDialog: {
    width: "100%",
  },
  rowInput: {
    marginTop: 10,
  },
  msgErr: {
    paddingTop: "5px",
    color: "orangered",
    fontSize: "0.8rem",
    textAlign: "right",
  },
}));

export default function AppRouter() {
  const dispatch = useDispatch();
  const { accessToken, userRole } = useAuth();
  const isLoading = useSelector((state) => state.user.isLoading);
  const isSuccess = useSelector((state) => state.user.isSuccess);
  const { userID: personalId } = useSelector((state) => state.user.profile);

  useEffect(async () => {
    if (accessToken) {
      HttpClient.setToken(accessToken);

      await dispatch(getUser());
      await dispatch(getAllActionUser());
      dispatch(getMasterData({ smartservice: true }));
    }
  }, [accessToken, dispatch]);

  useEffect(() => {
    if (!isLoading && personalId) {
      dispatch(getPersonalDetail({ personalId }));
      dispatch(checkWorkPermit({ personalId }));
      dispatch(getDigitalWorkpermitList({ personalId }));
    }
  }, [dispatch, isLoading, personalId]);

  useEffect(() => {
    if (accessToken) {
      dispatch(getSmartServiceList());
      dispatch(getSmartServiceListLTR());
    }
  }, [accessToken, dispatch]);

  return (
    <Router>
      <Switch>
        <Route path="/design-system">
          <DesignSystemPage />
        </Route>
        <Route path="/logout">
          <LogoutPage />
        </Route>
        {/* <PrivateRoute path="/login" restricted={false}>
          <LoginPage />
        </PrivateRoute> */}
        {/* Draft Login */}
        <Route path="/cookie-policy">
          <CookiePrivacyPage />
        </Route>
        <PrivateRoute path="/login" restricted={false}>
          <LoginPage_Darf />
        </PrivateRoute>
        <PrivateRoute path="/register" restricted={false}>
          <RegisterPage />
        </PrivateRoute>

        <PrivateRoute path="/forgot_password" restricted={false}>
          <ForgotPasswordPage />
        </PrivateRoute>
        <PrivateRoute path="/email_auth" restricted={false}>
          <RedirectConfirmPage />
        </PrivateRoute>
        <PrivateRoute path="/confirm_agency" restricted={false}>
          <RedirectConfirmPageAgency />
        </PrivateRoute>
        {/* End Darft */}
        <PrivateRoute path="/login-offline" restricted={false}>
          <LoginOfflinePage />
        </PrivateRoute>
        <PrivateRoute path="/select-role">
          <SelectRolePage />
        </PrivateRoute>
        <PrivateRoute path="/select-type">
          <SelectTypeLogin />
        </PrivateRoute>

        <PrivateRoute path="/personal-list">
          <PersonalListPage />
        </PrivateRoute>
        <PrivateRoute path="/personal-detail/:personalId">
          <PersonalDetailPage />
        </PrivateRoute>
        <PrivateRoute path="/personal/:personalId/signature">
          <PersonalSignaturePage />
        </PrivateRoute>
        <PrivateRoute path="/admin" byPass={false}>
          <AdminRouter />
        </PrivateRoute>
        <PrivateRoute path="/cancel-visa/:personal">
          <CancelVisaPage />
        </PrivateRoute>
        <PrivateRoute path="/status-report/:personal">
          <StatusReportPage />
        </PrivateRoute>
        <PrivateRoute path="/extension">
          <ExtensionPage />
        </PrivateRoute>
        <PrivateRoute path="/appointment/:draftId">
          <AppointmentTab />
        </PrivateRoute>
        <PrivateRoute path="/preApprove/:draftId">
          <PreApproved />
        </PrivateRoute>
        <PrivateRoute path="/">
          <HomePage />
        </PrivateRoute>
      </Switch>
    </Router>
  );
}

function AdminRouter() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { accessToken, userRole } = useAuth();
  const pinexist = useSelector((state) => state.pin.exist);
  const [open, setOpen] = React.useState(false);
  const { isLoading, isFailure, isSuccess, error } = useSelector(
    (state) => state.pin
  );
  const { showLoading, hideLoading } = useModalLoading();

  useEffect(() => {
    dispatch(pinExist());
  }, [dispatch]);
  useEffect(() => {
    if (!isLoading) {
      if (isSuccess) {
        hideLoading();
        if (pinexist === false) {
          setOpen(true);
        } else if (pinexist === true) {
          setOpen(false);
        }
      } else if (isFailure) {
        hideLoading();
        setOpen(true);
        alert(error?.message);
      }
    }
  }, [
    dispatch,
    pinexist,
    hideLoading,
    error?.message,
    isFailure,
    isLoading,
    isSuccess,
  ]);

  useEffect(() => {
    if (!accessToken) return;

    dispatch(getNotifications());
    const interval = setInterval(() => {
      dispatch(getNotifications());
    }, notificationTime);
    return () => clearInterval(interval);
  }, [dispatch, accessToken]);

  useEffect(() => {
    if (userRole !== 'Admin') {
      history.replace("/logout");
    }
  }, [])

  const handleClose = async (pin) => {
    setOpen(false);
  };

  if (userRole !== 'Admin') {
    return null
  }

  return (
    <Fragment>
      {/* <PinDialog open={open} onClose={handleClose} /> */}
      <Switch>
        <Route path="/admin/smart-visa">
          <SmartVisaPage />
        </Route>
        <Route path="/admin/setting">
          <SettingPage />
        </Route>
        <Route path="/admin/dashboard">
          <DashboardPage />
        </Route>
        <Route path="/admin/report/industry">
          <ReportIndustryPage />
        </Route>
        <Route path="/admin/report/visaType">
          <ReportVisaTypePage />
        </Route>
        <Route path="/admin/report/kpi">
          <ReportKPIPage />
        </Route>
        <Route path="/admin/kpi-dashboard" exact>
          <KPIDashboardPage />
        </Route>
        <Route path="/admin/kpi-dashboard/details/:stepKPIID" exact>
          <KPIDashboardDetailPage />
        </Route>
        <Route path="/">
          <HomeAdminPage />
        </Route>
      </Switch>
    </Fragment>
  );
}

function PinDialog(props) {
  const dispatch = useDispatch();
  const defaultInputs = {
    pin: "",
    confirm: "",
  };
  const classes = useStyles();
  const { onClose, open } = props;
  const [input, setInput] = useState(defaultInputs);
  const [checkInput, setCheckInput] = useState(null);
  const { isLoading } = useSelector((state) => state.pin);

  const handleClose = () => {
    onClose();
  };

  const handleSave = async () => {
    const body = {
      pinPassword: input.pin,
    };
    await dispatch(addPin(body));
    onClose(input.pin);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInput({
      ...input,
      [name]: value,
    });
  };

  useEffect(() => {
    if (input.pin === input.confirm) {
      setCheckInput(true);
    } else {
      setCheckInput(false);
    }
  }, [input]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="xs"
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title"> Enter new 6-digit PIN</DialogTitle>
      <DialogContent>
        <div>
          <TextField
            value={input.pin}
            variant="outlined"
            label="Pin"
            className={classes.textDialog}
            type="number"
            name="pin"
            onInput={(e) => {
              e.target.value = Math.max(0, parseInt(e.target.value))
                .toString()
                .slice(0, 6);
            }}
            inputProps={{ maxLength: 6 }}
            onChange={handleInputChange}
          />
        </div>
        <div className={classes.rowInput}>
          <TextField
            value={input.confirm}
            variant="outlined"
            className={classes.textDialog}
            label="Confirm Pin"
            type="number"
            name="confirm"
            onInput={(e) => {
              e.target.value = Math.max(0, parseInt(e.target.value))
                .toString()
                .slice(0, 6);
            }}
            inputProps={{ maxLength: 6 }}
            onChange={handleInputChange}
          />
        </div>
        {checkInput === false && (
          <div className={classes.msgErr}>Pin does not match.</div>
        )}
        <div className={classes.warpButtonDialogSave}>
          {/* <Button variant="outlined" size="medium" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
            Close
          </Button> */}
          <Button
            disabled={
              !checkInput === true ||
              !input.pin ||
              !input.confirm ||
              input.pin.length !== 6 ||
              input.confirm.length !== 6
            }
            variant="contained"
            size="medium"
            color="primary"
            onClick={() => handleSave()}
            className={classes.buttonDialogSave}
          >
            {isLoading && <Loading />}
            {!isLoading && <span>Save</span>}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
